import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar';
import Delete from '@material-ui/icons/Delete'
import Info from '@material-ui/icons/Visibility'
import Edit from '@material-ui/icons/Edit'
import Table from './Table'
import Header from './Header'
import { browserHistory } from 'react-router'
import Button from '@material-ui/core/Button'
import token from '../config/jwt_token'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import DialogBox from './Dialogbox'
import CSVGenerator from '../utils/json2csv'
import PaymentInitAuth from './PaymentInitAuth'
import { getBankUploadedDetails } from '../utils/PaymentRequestApiUtils'
import moment from 'moment'
import { LinearProgress } from "@material-ui/core";

class PaymentProcess extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      data: [],
      columns: [],
      fromDate: '',
      toDate: '',
      fromDateErr: false,
      fromDateErrText: '',
      toDateErr: false,
      toDateErrText: '',
      showDialogBox: false,
      snackOpen: false,
      open: false,
      inProgress: false,
    }
  }
  async componentDidMount() {
    if (!token) {
      browserHistory.push('/')
      return
    }
    this.setState({ inProgress: true },() => {
      getBankUploadedDetails(this.state.fromDate, this.state.toDate).then(response => {
        if (response && response.status === 'success') {
          let {data, columns} = this.state
          data = response.data.map(data => {
            return {
              ...data,
              instruction_date: moment(data.instruction_date).format('DD-MM-YYYY'),
              cost_center: (data.total_cost_centers>1)?'Multi Cost centers':data.cost_center,
              full_invoice_amount_display: (data.partial_payment_percentage && data.full_invoice_amount) ? data.full_invoice_amount : '-'
            }
          })
          columns = [{
            key: 'payment_request_id', // actually payment_request_code
            Header: 'PR Index'
          },
            {
              key: 'payment_request_code',
              Header: 'Payment Code'
            },
            {
              key: 'cust_ref_number',
              Header: 'Customer Ref No'
            },
            {
              key: 'vendor_name',
              Header: 'Vendor Name'
            },
            {
              key: 'cost_center',
              Header: 'Cost Center'
            },
            {
              key: 'instruction_date',
              Header: 'Date of payment'
            },
            {
              key: 'instrument_amount',
              Header: 'Amount'
            },
            {
              key: 'full_invoice_amount_display',
              Header: 'Total PO Amount'
            },
            {
              key: 'transaction_type',
              Header: 'Mode of payment'
            }]
          this.setState({columns, data, inProgress: false})
        }
        else {
          this.setState({inProgress: false })
        }
      })
    })


  }
  handleChange = (props) => (event, index, value) => {
    if (props === 'fromDate') {
      if (this.state.toDate !== '' && this.state.toDate < event.target.value) {
        this.setState({ snackOpen: true, snackMessage: 'From date should be lessthan To date' })
        return
      }
    }
    else if (props === 'toDate') {
      if (this.state.fromDate !== '' && this.state.fromDate > event.target.value) {
        this.setState({ snackOpen: true, snackMessage: 'To date should be greaterthan From date' })
        return
      }
    }
    this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })

  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  async submitFilter() {
    this.setState({ inProgress: true },() => {
      getBankUploadedDetails(this.state.fromDate, this.state.toDate).then(response => {
        if (response) {
          if (response.status === 'success') {
            let data = response.data.map(data => {
              return {
                ...data,
                instruction_date: moment(data.instruction_date).format('DD-MM-YYYY'),
                cost_center: (data.total_cost_centers>1)?'Multi Cost centers':data.cost_center
              }
            })
            this.setState({ data, inProgress: false })
          }
          else {
            this.setState({snackMessage: response.message, snackOpen: true, inProgress: false })
          }
        }
      })
    })
  }
  clearFilter() {
    this.setState({ fromDate: '', toDate: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
  }
  getCSVData() {
    let data = this.state.data.map((cur) => ({
      'PR Index': cur.payment_request_id,
      'Customer Ref No': cur.cust_ref_number,
      'Vendor Name': cur.vendor_name,
      'Cost Center': cur.cost_center,
      'Date of payment': cur.instruction_date,
      'Amount': cur.instrument_amount,
      'Total PO Amount': cur.full_invoice_amount_display,
      'Mode of payment': cur.transaction_type,
      'Email': "finance@zolostays.com",
    }))
    let headers = [
      'PR Index',
      'Customer Ref No',
      'Vendor Name',
      'Cost Center',
      'Date of payment',
      'Amount',
      'Total PO Amount',
      'Mode of payment',
      'Email']

    return {
      data: data,
      headers: headers,
      filename: 'Generated Buf'
    }
  }

  generateCSV() {
    let csvData = this.getCSVData()
    CSVGenerator(csvData.headers, csvData.data, csvData.filename)
  }

  render() {
    return (
      <MuiThemeProvider>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Generated BUF</h2>
              <p className="zaps-page-subtitle">Bank uploaded file details and transaction records</p>
            </div>
          </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div>
              <TextField
                id="date"
                label="From Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.state.fromDate}
                onChange={this.handleChange('fromDate')}
                style={{ marginRight: '20px' }}
                error={this.state.fromDateErr}
                helperText={this.state.fromDateErrText}
                margin='normal'
              />
              <TextField
                id="date"
                label="To Date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                value={this.state.toDate}
                onChange={this.handleChange('toDate')}
                style={{ marginRight: '20px' }}
                error={this.state.toDateErr}
                helperText={this.state.toDateErrText}
                margin='normal'
              />
            </div>
            <div style={{}}>
              <Button variant="contained" size="large" color="primary" onClick={this.submitFilter.bind(this)}
                style={{ marginRight: '20px', marginTop: '25px' }}>
                Submit Filter
                </Button>
              <Button variant="contained" size="large" color="primary" onClick={this.clearFilter.bind(this)}
                style={{ background: 'red', marginTop: '25px' }}>
                Clear Filter
                </Button>
            </div>
          </div>
          <div style={{ marginTop: '25px' }} >
            <Button variant="contained" size="large" color="primary" onClick={this.generateCSV.bind(this)}>
              Download CSV
                </Button>
          </div>
        </div>
        <Table data={this.state.data} columns={this.state.columns} />
        <Dialog
          open={this.state.inProgress}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            Loading...
            <br/><br/>
            <LinearProgress />
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
        />
          
        </div>{/* end zaps-page-wrap */}
      </MuiThemeProvider>
    )
  }
}
export default PaymentProcess



// WEBPACK FOOTER //
// ./src/components/BankUploadedDetails.js